import { defineStore } from 'pinia'

export const useUserStore = defineStore('storeUser', {
    state: () => ({
        gottesdienste: [],
        news: [],
    }),
    actions: {
        async fetchData() {
            try {
                const response = await fetch(`${process.env.VUE_APP_API_URL}/gottesdienste`)
                this.gottesdienste = await response.json();
            } catch (error) {
                console.error(error)
            }
        },
        async getData() {
            if(this.gottesdienste.length == 0) {
                await this.fetchData();
            }
            return this.gottesdienste;
        },
        async fetchNews() {
            try {
                const response = await fetch(`${process.env.VUE_APP_CMS_URL}/items/Neuigkeiten`)
                this.news = (await response.json()).data.sort((a,b) => {
                    let dateA = new Date(a["Tag_des_Ereignisses"]);
                    let dateB = new Date(b["Tag_des_Ereignisses"]);
                    let today = new Date();

                    if(dateB < today) {
                        return -1;
                    } else if(dateA < today) {
                        return 1;
                    } else
                        return dateA < dateB ? -1 : 1;
                });
            } catch (error) {
                console.error(error)
            }
        },
        async getNews() {
            if(this.news.length == 0) {
                await this.fetchNews();
            }
            return this.news;
        },
    },
})